import Slider from "react-slick";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import Flag1 from "../../assets/images/flags/Flag1.png";
import Flag2 from "../../assets/images/flags/Flag2.png";

const MatchInfoBox = ({ sportsData }) => {
  const navigate = useNavigate();
  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const handleMatchCardClick = (event) => {
    navigate(
      `/detail-page/${event?.marketSlug}/${event?.matchid}/${event?.marketid}/${event?.SportId}`
    );
  };
  return (
    <div className="match_info_slider">
      <Slider {...settings}>
        {sportsData &&
          sportsData.length &&
          sportsData.map((item, index) => {
            return item.values.map((v, i) => {
              // const d = moment(v?.matchdate);
              let matchNames = v?.matchName.trim().toLowerCase().includes("vs")
                ? v?.matchName.split(" vs ")
                : v?.matchName.split(" v ");
              return (
                <div onClick={() => handleMatchCardClick(v)}>
                  <div className="info_box">
                    <div className="match">
                      <div className="tournament">{item?.sportname}</div>
                      <div className="tournament">{v?.series_name}</div>
                      <div className="time">
                        {moment(v?.matchdate).format("dddd DD MMM, hh:mm A")}
                      </div>
                    </div>

                    <div className="participants">
                      <div className="item">
                        <img className="flag" src={Flag1} alt="Team Flag" />
                        <div className="name">{matchNames?.[0]}</div>
                      </div>
                      <div className="item">
                        <img className="flag" src={Flag2} alt="Team Flag" />
                        <div className="name">{matchNames?.[1]}</div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            });
          })}
      </Slider>
    </div>
  );
};

export default MatchInfoBox;
